import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const apiGet = (path, params) => api.get(path, { params }).then((r) => r.data);
export const apiPost = (path, data) => api.post(path, data).then((r) => r.data);

export { API };
export default api;
